
import { EngagementWithDetails } from '../../types/engagement';

interface EngagementDashboardProps {
  engagement: EngagementWithDetails;
}

export default function EngagementDashboard({ engagement }: EngagementDashboardProps) {
  // Calculate statistics
  const totalContacts = engagement.contacts.length;
  const contactsByStep = engagement.contactStatuses.reduce((acc, status) => {
    if (status.step_id) {
      acc[status.step_id] = (acc[status.step_id] || 0) + 1;
    }
    return acc;
  }, {} as Record<string, number>) || {};

  // Calculate contacts not started (those without a step status)
  const contactsInSteps = Object.values(contactsByStep).reduce((a, b) => a + b, 0);
  const notStartedCount = totalContacts - contactsInSteps;

  // Find the last step for completed count
  const lastStepId = engagement.steps[engagement.steps.length - 1]?.id;
  const completedCount = lastStepId ? (contactsByStep[lastStepId] || 0) : 0;

  return (
    <div className="space-y-6">
      {/* Overview Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-dark-800 rounded-lg p-4">
          <h3 className="text-gray-400 text-sm font-medium mb-2">Total Contacts</h3>
          <p className="text-2xl font-bold text-white">{totalContacts}</p>
        </div>
        <div className="bg-dark-800 rounded-lg p-4">
          <h3 className="text-gray-400 text-sm font-medium mb-2">Not Started</h3>
          <p className="text-2xl font-bold text-white">{notStartedCount}</p>
        </div>
        <div className="bg-dark-800 rounded-lg p-4">
          <h3 className="text-gray-400 text-sm font-medium mb-2">Completed</h3>
          <p className="text-2xl font-bold text-white">{completedCount}</p>
        </div>
      </div>

      {/* Progress by Step */}
      <div className="bg-dark-800 rounded-lg p-6">
        <h2 className="text-lg font-medium text-white mb-4">Progress by Step</h2>
        <div className="space-y-4">
          {engagement.steps.map((step) => {
            const contactCount = contactsByStep[step.id] || 0;
            const percentage = totalContacts > 0 ? (contactCount / totalContacts) * 100 : 0;
            
            return (
              <div key={step.id} className="space-y-2">
                <div className="flex justify-between text-sm">
                  <span className="text-white">{step.name}</span>
                  <span className="text-gray-400">{contactCount} contacts ({percentage.toFixed(1)}%)</span>
                </div>
                <div className="h-2 bg-dark-700 rounded-full overflow-hidden">
                  <div 
                    className="h-full bg-blue-500 rounded-full transition-all duration-500"
                    style={{ width: `${percentage}%` }}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
